import { Box, Button } from '@mui/material';

import { Localized } from 'dg-web-shared/lib/Localization';
import {
    RequestStatus,
    ServerRequestState,
} from 'dg-web-shared/lib/hooks/ServerStateHooks';

export function CancelSave<DT, ET>({
    onCancel,
    onSave,
    requestState,
    saveDisabled,
    loading,
}: {
    onCancel?: () => void;
    onSave?: () => void;
    requestState: ServerRequestState<DT, ET>;
    saveDisabled?: boolean;
    loading?: boolean;
}) {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                width: onCancel ? '100%' : '50%',
                marginLeft: 'auto',
            }}
        >
            {onCancel && (
                <Button
                    variant="outlined"
                    onClick={onCancel}
                    fullWidth
                    sx={{ marginRight: 1 }}
                >
                    <Localized
                        de="Abbrechen"
                        fr="Annuler"
                        it="Annulla"
                        en="Cancel"
                    />
                </Button>
            )}

            <Button
                variant="contained"
                type="submit"
                color="primary"
                sx={{ marginLeft: 1 }}
                disabled={saveDisabled}
                loading={
                    requestState.status === RequestStatus.PENDING || loading
                }
                onClick={onSave}
                fullWidth
            >
                <Localized de="Speichern" fr="Save" it="Salva" en="Save" />
            </Button>
        </Box>
    );
}
